import React from 'react';
import Table from '../../components/Table';
import { usePhysicalPonds } from 'hooks/usePhysicalPonds';

function Ponds() {
  const {
    physicalPonds,
    exportData,
    openProgress,
    columns,
    columnsForExport,
    errors,
    errorsWhenPosting,
    pond,
    handleImportDataPost,
    handleCloseSnackbar,
  } = usePhysicalPonds();

  return (
    <Table
      onPost={handleImportDataPost}
      title="Viveiros"
      route="/ponds/"
      routeAdd="/pond/"
      columns={columns}
      columnsForExport={columnsForExport}
      data={physicalPonds}
      dataLoaded={openProgress}
      exportData={exportData}
      hasError={errors.length > 0}
      importButtonVisible
      errorsPost={errorsWhenPosting}
      onCloseSnackbar={handleCloseSnackbar}
      pond={pond}
    />
  );
}

export default Ponds;
